import { PlanTypeName, PlanTypeNameType } from '../constants'

/**
 * プラン制限に関するユーティリティ関数群
 */
export const PlanRestrictions = {
  /**
   * 高度な画像編集機能が利用可能かどうかを判定
   * @param planType プラン種別
   * @returns 全プランでtrue
   */
  hasAdvancedImageEditing: (planType: string | PlanTypeNameType | undefined): boolean => {
    if (!planType) {
      return false;
    }
    // 文字列として比較も行い、より堅牢にする
    // 全プラン対応
    const allPlans = Object.values(PlanTypeName);
    const result = allPlans.includes(planType as PlanTypeNameType) ||
                   allPlans.includes(planType);
    return result;
  },

  /**
   * 個別処理モードで許可される最大画像枚数を取得
   * @param planType プラン種別
   * @returns 全プランで50枚
   */
  getMaxIndividualImages: (planType: string | PlanType | undefined): number => {
    // 全プランで50枚まで個別処理可能
    return 50;
  },

  /**
   * コントラスト調整機能が利用可能かどうかを判定
   * @param planType プラン種別
   * @returns 全プランでtrue
   */
  canUseContrastAdjustment: (planType: string | PlanTypeNameType | undefined): boolean => {
    return PlanRestrictions.hasAdvancedImageEditing(planType);
  },

  /**
   * ホワイトバランス調整機能が利用可能かどうかを判定
   * @param planType プラン種別
   * @returns 全プランでtrue
   */
  canUseWhiteBalance: (planType: string | PlanTypeNameType | undefined): boolean => {
    return PlanRestrictions.hasAdvancedImageEditing(planType);
  },

  /**
   * プラン制限メッセージを取得
   * @param planType プラン種別
   * @param processingMethod 処理方法（一括処理: 'single', 個別処理: 'individual'）
   * @returns 表示すべきメッセージ、表示不要の場合はnull
   */
  getPlanRestrictionMessage: (
    planType: string | PlanTypeNameType | undefined,
    processingMethod: 'single' | 'individual'
  ): string | null => {
    // 全プラン対応のため、制限なし
    const isLimitedPlan = !planType;
    const isAdvancedPlan = Object.values(PlanTypeName).includes(planType as PlanTypeNameType) ||
                          Object.values(PlanTypeName).includes(planType);

    if (isLimitedPlan && processingMethod === 'individual') {
      return `Basic/Pro/Eliteプランの
「個別処理」でご利用可能です
Basic/Pro/Eliteへ
アップグレードする必要があります
ご希望の場合はこちらのフォーム
までお問合せください`;
    }

    // Basic/Pro/Eliteプランで一括処理を選択している場合
    if (isAdvancedPlan && processingMethod === 'single') {
      return `Basic/Pro/Eliteプランの
「個別処理」でご利用可能です`;
    }

    // その他の場合はメッセージを表示しない
    return null;
  },

  /**
   * 個別処理ボタンを無効化すべきかどうかを判定
   * @param planType プラン種別
   * @param uploadedImagesCount アップロード済み画像数
   * @returns 無効化すべき場合true
   */
  shouldDisableIndividualProcessing: (
    planType: string | PlanTypeNameType | undefined,
    uploadedImagesCount: number
  ): boolean => {
    // Mini/Liteプランの場合は常に無効化
    const hasAdvanced = PlanRestrictions.hasAdvancedImageEditing(planType);
    if (!hasAdvanced) {
      return true;
    }
    // アップロード枚数による制限はなし（最大50枚まで個別処理可能）
    return false;
  }
};
